import { gql } from "graphql-request";

export const CREATE_COURSE_MUTATION = gql`
  mutation ($input: CreateCourseInput!) {
    createcourse(input: $input) {
      id
      thumbnail
      name
      description
      subtitle
      public
      owner {
        name
        id
        profile_link
        totalCourses
        totalLearners
        signature
        social_links
        short_bio
      }
      user_profile {
        id
        name
        profile_pic
      }
      files {
        id
        course_id
        media
      }
      urls {
        url
        id
      }
      active
      free
      price
      discounted_price
      currency
      members_count
      classes {
        id
        name
      }
      is_enrolled
      section {
        id
        title
        lectures {
          id
          title
          description
          fileLink
          url
          fileType
          article
          duration
          completed
        }
        total_lecs
        sec_mins
        quiz {
          id
          title
          details
          max_marks
          template {
            ques_count
          }
        }
      }
      course_mins
      total_lecs
      progress_bar
      course_level
      is_draft
      payment_link
      meeting_link
      start_time
      repeat
      start_date
      repeat_until
      repeat_weekdays
      repeat_monthly_date
      isLive
      prerequisites
      learning_outcomes
      tags
      preview_video
      preview_video_link
      timezone
    }
  }
`;

export const EDIT_COURSE_MUTATION = gql`
  mutation ($input: UpdateCourseInput!) {
    updatecourse(input: $input) {
      id
      thumbnail
      name
      description
      subtitle
      public
      owner {
        name
        id
        profile_link
        totalCourses
        totalLearners
        signature
        social_links
        short_bio
      }
      user_profile {
        id
        name
        profile_pic
      }
      files {
        id
        course_id
        media
      }
      urls {
        url
        id
      }
      active
      free
      price
      discounted_price
      currency
      members_count
      classes {
        id
        name
      }
      is_enrolled
      section {
        id
        title
        lectures {
          id
          title
          description
          fileLink
          url
          fileType
          article
          duration
          completed
        }
        total_lecs
        sec_mins
        quiz {
          id
          title
          details
          max_marks
          template {
            ques_count
          }
        }
      }
      course_mins
      total_lecs
      progress_bar
      course_level
      is_draft
      payment_link
      meeting_link
      start_time
      repeat
      start_date
      repeat_until
      repeat_weekdays
      repeat_monthly_date
      isLive
      prerequisites
      learning_outcomes
      tags
      preview_video
      preview_video_link
      timezone
    }
  }
`;

export const DELETE_COURSE_MUTATION = gql`
  mutation ($input: ID!) {
    deletecourse(id: $input) {
      message
    }
  }
`;

export const UPDATE_COURSE_STATUS_MUTATION = gql`
  mutation ($input: UpdateCourseInput!) {
    updatecourse(input: $input) {
      id
      name
      active
      utimestamp
    }
  }
`;

export const ENROLL_COURSE_MUTATION = gql`
  mutation ($input: PaymentInput, $id: ID!) {
    enrollcourse(input: $input, id: $id) {
      status
      message
    }
  }
`;

export const UPDATE_COURSE_MUTATION = gql`
  mutation ($input: UpdateCourseInput!) {
    updatecourse(input: $input) {
      id
      thumbnail
      name
      description
      subtitle
      public
      owner {
        name
        id
        profile_link
        totalCourses
        totalLearners
        signature
        social_links
        short_bio
      }
      user_profile {
        id
        name
        profile_pic
      }
      files {
        id
        course_id
        media
      }
      urls {
        url
        id
      }
      active
      free
      price
      discounted_price
      currency
      members_count
      classes {
        id
        name
      }
      is_enrolled
      section {
        id
        title
        lectures {
          id
          title
          description
          fileLink
          url
          fileType
          article
          duration
          completed
        }
        total_lecs
        sec_mins
        quiz {
          id
          title
          details
          max_marks
          template {
            ques_count
          }
        }
      }
      course_mins
      total_lecs
      progress_bar
      course_level
      is_draft
      payment_link
      meeting_link
      start_time
      repeat
      start_date
      repeat_until
      repeat_weekdays
      repeat_monthly_date
      isLive
      prerequisites
      learning_outcomes
      tags
      preview_video
      preview_video_link
      timezone
    }
  }
`;

export const PUBLISH_COURSE_AND_SECTION_MUTATION = gql`
  mutation ($input: ID!) {
    pubCourseandSection(course_id: $input) {
      id
      thumbnail
      name
      description
      subtitle
      public
      owner {
        name
        id
        profile_link
        totalCourses
        totalLearners
        signature
        social_links
        short_bio
      }
      user_profile {
        id
        name
        profile_pic
      }
      files {
        id
        course_id
        media
      }
      urls {
        url
        id
      }
      active
      free
      price
      currency
      members_count
      classes {
        id
        name
      }
      is_enrolled
      section {
        id
        title
        lectures {
          id
          title
          description
          fileLink
          url
          fileType
          article
          duration
          completed
          isPublished
        }
        total_lecs
        sec_mins
        quiz {
          id
          title
          details
          max_marks
          template {
            ques_count
          }
        }
      }
      course_mins
      total_lecs
      progress_bar
      is_draft
    }
  }
`;

export const CREATE_TEMPLATE_MUTATION = gql`
  mutation ($input: TemplateInput!) {
    create_template(input: $input) {
      id
      temp_owner {
        id
        name
      }
      title
      details
      marks
      questions {
        id
        text
        marks
        is_mandatory
        question_type
        choice {
          id
          is_correct
          img
          choice_text
          correct_choice
          correct_list {
            correct_choice
          }
        }
      }
      timestamp
      utimestamp
      ques_count
    }
  }
`;

export const GET_TEMPLATE_QUERY = gql`
  query {
    templates {
      id
      temp_owner {
        id
        name
      }
      title
      details
      marks
      ques_count
    }
  }
`;

export const CREATE_QUIZ_MUTATION = gql`
  mutation ($input: QuizInput!) {
    create_quiz(input: $input) {
      id
      title
      details
      max_marks
      due_date
      template {
        id
        title
        marks
        questions {
          id
          text
          marks
          is_mandatory
          question_type
        }
        ques_count
      }
      is_timed
      duration
      question_randomized
      reattempt
      show_answers
      timestamp
      utimestamp
    }
  }
`;

export const GET_QUIZ_QUERY = gql`
  query GetQuizById($id: ID!) {
    quiz(id: $id) {
      id
      title
      details
      template {
        id
        title
        marks
        questions {
          id
          text
          marks
          is_mandatory
          question_type
          choice {
            id
            choice_text
            correct_choice
            is_correct
            img
            correct_list {
              correct_choice
            }
          }
        }
        ques_count
      }
      is_timed
      duration
      question_randomized
      reattempt
      show_answers
      max_marks
      is_lock
      due_date
      timestamp
      utimestamp
      user_submission {
        id
        attempt
        marks
        submission_status
        is_submitted
        is_returned
        user_answers
      }
      classes {
        id
        name
        class_owner {
          id
          name
        }
      }
      group {
        id
        name
        group_owner {
          id
          name
        }
      }
    }
  }
`;
